export default class HoverController {
  constructor(host, delay = 50) {
    this.host = host;
    this.delay = delay;
    this.timeout = null;
    host.addController(this);
  }

  hostDisconnected() {
    this.clearTimeout();
  }

  debounceHover(siblingId) {
    this.clearTimeout();
    this.timeout = setTimeout(() => {
      this.host._handleHoverIn(Number(siblingId));
    }, this.delay);
  }

  clearTimeout() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
}
